import { authService } from '../api';
import { useApi } from './useApi';

export const useVerifyEmail = () => {
  const { loading, error, execute } = useApi({
    successMessage: 'Email verified successfully!',
    showSuccessToast: true,
    showErrorToast: true,
    // Remove automatic navigation - let the component handle it
  });

  const verifyEmail = async (token: string) => {
    return execute(() => authService.verifyEmail(token));
  };

  return {
    verifyEmail,
    loading,
    error,
  };
};
